<template>
  <tk-container
    class=""
    :probeType="3"
    infiniteScroll
    ref="resetList"
    @loadingMore="loadMore"
  >
  <!-- @refresh="onRefresh" -->
    <tk-flex
      middle
      :gutter="10"
      slot="header"
      class="flex items-center mb-10 px-15 pt-15"
    >
      <div class="pb-3">
        <global-back />
      </div>
      <global-title class="flex-grow" :is-show-right="false" />
    </tk-flex>
    <div class="p-x-15 pb-15 h-full">
      <div class="h-8" />
      <div class="flex flex-col">
        <div class="flex-grow">
          <van-row
            v-if="list.length > 0"
          >
            <van-col
              v-for="(item, index) in list"
              :class="index === 0 ? 'mt-0' : 'mt-10'"
              :key="index"
              span="24"
            >
              <course-card
                :data="item.course"
                direction="horizontal"
              />
            </van-col>
          </van-row>
          <div v-else>
            <global-empty
              word="没有找到相关内容～"
            />
          </div>
        </div>
      </div>
    </div>
  </tk-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      list: [],
    }
  },
  computed: {
    ...mapState({
      user: state => state.user,
    }),
  },
  methods: {
    onRefresh () {
      this.list = []
      this.$refs.resetList.resetInfiniteScroll()
    },
    async loadMore (page, next) {
      const res = await this.$tkParse.getList('/classes/exchangeRecord', {
        params: {
          order: '-updatedAt',
          limit: 10,
          skip: page * 10,
          include: 'course',
          where: {
            exchangeUser: this.user.objectId,
            status: '已使用',
          },
        },
      })
      this.list = [...this.list, ...res]
      if (res.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
  },
}
</script>

<style scoped lang="scss">
</style>
